import React, { Fragment } from "react";

const SectionComponent =  ({title, text, children}) => (
    <Fragment>
        <h1>{title}</h1>
        <p>{text}</p>

        {children}
    </Fragment>
)

export default SectionComponent